<template>
  <div class="LibStatusesComponent">
    <div class="progress-table">
        
            
            <b-list-group class="progress-container">
                <b-list-group-item  v-for="item,index in libStatuses" :key="item.timestamp+index" class="d-flex justify-content-between align-items-center">
                    <b-row class="container">
                        <b-col cols="4">
                            {{item.libraryName}}
                        </b-col>
                        <b-col cols="4">
                            
                            <span v-if="item.status == 'Error'" class="red">{{item.status}}</span>
                            <span v-if="item.status == 'In Sync'" class="green">{{item.status}}</span>
                            <span v-if="item.status != 'Error' && item.status != 'In Sync'">{{item.status}}</span>
                                
                        </b-col>
                        <b-col cols="4">
                            <span v-if="item.status != 'Error' && item.status != 'In Sync'">
                                <b-progress :variant="item.status=='Downloading'?'warning':'info'" :value="item.progress.done" :max="item.progress.total"></b-progress>
                            </span>
                            <span v-if="item.status == 'In Sync'">
                                {{ longDateToShort(item.timestamp) }}
                            </span>
                        </b-col>
                        
                    </b-row>
                </b-list-group-item>
            
                
            </b-list-group>
        
        
    </div>
    
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import * as Tools from './../../Tools/Tools'

export default {
    name: 'LibStatusesComponent',
    props:{
        lang: Object,
        data: Array,
        action: Object
    
    },
    components: {
        name: "LibStatusesComponent"

    },
    data () {
        return {
                                    
        }
    },
    computed: {
        rows() {
            return this.items.length
        },
        libStatuses(){

            return this.$store.getters.libStatuses;


        },
        
        cardColorsBg() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "dark";
            } else {
                return "secondary";
            }

        },
        cardColorsText() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "white";
            } else {
                return "dark"
            }

        },
    },
    created() {

        

    },
    watch: {
        value: function (newVal, oldVal) {


        }
    },
    updated() {



    },
    mounted: function () {

    },
    methods: {
        longDateToShort(date) {
            return Tools.longDateToShort(date);
        },


    }
}
</script>


<style lang="scss">
.LibStatusesComponent{
        
        
        height: 270px;
        overflow: auto;
        scrollbar-width: thin;
        .progress-container{
            
            margin: 10px;
        }
        .red{
            color: #E87C1E;
        }
        .green {
            color: #247f3e;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/LibStatusesComponent.vue